import { ArrowUpRight } from "lucide-react";
import { PRESS_ARTICLES } from "../../data/content";
import { Reveal } from "./Reveal";

export const PressArticles = () => {
  return (
    <section
      data-testid="press-articles"
      className="relative px-6 pb-28 lg:px-10 lg:pb-36"
    >
      <div className="mx-auto max-w-7xl">
        <div
          className="grid grid-cols-1 gap-px border sm:grid-cols-2 lg:grid-cols-3"
          style={{ borderColor: "var(--border)", background: "var(--border)" }}
        >
          {PRESS_ARTICLES.map((a, i) => (
            <Reveal key={a.url} delay={(i % 3) * 0.06}>
              <a
                href={a.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`press-article-${i}`}
                className="group flex h-full flex-col justify-between px-7 py-8 transition-colors"
                style={{ background: "var(--surface)" }}
              >
                <div className="flex items-start justify-between gap-4">
                  <span
                    className="font-accent text-[11px] uppercase tracking-[0.2em]"
                    style={{ color: "var(--accent)" }}
                  >
                    {a.outlet}
                  </span>
                  <ArrowUpRight
                    size={18}
                    className="shrink-0 -translate-y-0.5 opacity-40 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100"
                    style={{ color: "var(--accent)" }}
                  />
                </div>
                <h3 className="font-head mt-10 text-xl leading-snug text-[color:var(--text)]">
                  {a.title}
                </h3>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
